import { useContext } from 'react';
import StateContext from 'contexts/SSRData/SSRDataContext';

const useSSRData = () => useContext(StateContext);
export default useSSRData;
